jQuery('document').ready(function(){

    jQuery('.head-pick').click(function(){
        $('.headItem').removeClass('head-active');
        $(this).addClass('head-active');
        jQuery('.availRow, .localDeliveryDiv').hide();
        jQuery('.shippingItem, .localPickupDiv').show();
    })

    jQuery('.head-local').click(function(){
        $('.headItem').removeClass('head-active');
        $(this).addClass('head-active');
        jQuery('.availRow, .localPickupDiv').hide();
        jQuery('.shippingItem, .localDeliveryDiv').show();
    })

    jQuery('.head-ship').click(function(){ 
        $('.headItem').removeClass('head-active');
        $(this).addClass('head-active');
        jQuery('.availRow, .localDeliveryDiv, .localPickupDiv').hide();
        jQuery('.shippingItem').show();
        //jQuery('.variantAdd2Cart').show();
        //jQuery('.notAvaila').hide(); 
    })

    jQuery('.product-form__item .qtyMinus').click(function(e){
        e.preventDefault()
        var qty = parseInt($(this).parent().find('#Quantity-product-template').val())
        if(qty > 0) {
            qty--;
            $(this).parent().find('#Quantity-product-template').val(qty)
        }
    })

    jQuery('.product-form__item .qtyPlus').click(function(e){
        e.preventDefault()
        var qty = parseInt($(this).parent().find('#Quantity-product-template').val())
        qty++;
        $(this).parent().find('#Quantity-product-template').val(qty);
    })

    setTimeout(function(){
        if($('.product-template__container .grid.product-single').attr('data-beer-type') === 'false') {
    
            $('#shopify-section-product-recommendations .section-header h2').text('EXPLORE MORE');
    
            $('#shopify-section-product-recommendations').insertBefore('#looxReviews')
            
            $('body.template-product').addClass('non-beer');
        }

        if($('.product-recommendations__inner .grid__item').length) {
            $(".product-recommendations__inner .grid__item").hide();
           var fProducts = $(".product-recommendations__inner .grid__item").get().sort(function(){ 
                return Math.round(Math.random())-0.5; //so we get the right +/- combo
               }).slice(0,4);
    
             $(fProducts).show();  
        }

    }, 1500)




    $(document).on('mouseover', ".bottomThreeSection .bottomRowHolder .bottomRowURL a", function() {
        $(this).closest('.bottomRowHolder').addClass("cta__block-white");
    });
    $(document).on('mouseout', ".bottomRowURL a", function() {
        $(this).closest('.bottomRowHolder').removeClass("cta__block-white");
    });

    $(document).on('mouseover', ".cta__button", function() {
        $(this).closest('.cta__block').addClass("cta__block-white");
    });
    $(document).on('mouseout', ".cta__button", function() {
        $(this).closest('.cta__block').removeClass("cta__block-white");
    });

    if($('.noShipping.shippingItem').length) {
        $('.headItem.head-ship').removeClass('head-active');
        $('.headItem.head-local').addClass('head-active');
        $('.headItem.head-local').addClass('noBorder');
        $('.headItem.head-ship').hide();
    }

});